/* Hysteresis figure for the animated-proof section, registered as 'hysteresis'.
   Documented in kg-custom-sections.md § animated-proof.
   An adapter only: the drawing and motion are assets/animated-proof-follicle.js, unchanged. The segment
   times are the ones the follicle diagram's own carousel used, so the plate plays exactly as before. */
(function () {
  'use strict';
  var SETTLE_SECONDS = 0.8;       // the five-blade stroke holds after release before step 2 begins
  var RESET_LEAD_SECONDS = 0.2;   // each figure stops just before its reset fade

  function figureFor(svg) {
    if (!svg) throw new Error('Hysteresis figure: plate is missing an svg[data-fig]');
    return svg.__fig || new window.FollicleFigure(svg);
  }
  function mountHysteresis(plate) {
    var multi = figureFor(plate.querySelector('svg[data-fig="1"]'));
    var single = figureFor(plate.querySelector('svg[data-fig="2"]'));
    var firstStepEnd = multi.rel1 + SETTLE_SECONDS;
    var regrowthEnd = multi.sh.r0 - RESET_LEAD_SECONDS;
    var singleEnd = single.sh.r0 - RESET_LEAD_SECONDS;
    return {
      fig1: multi, fig2: single,
      segments: [[0, firstStepEnd], [firstStepEnd, regrowthEnd], [0, singleEnd]],
      still: [regrowthEnd, singleEnd]
    };
  }
  window.KGFigures = window.KGFigures || {};
  window.KGFigures.hysteresis = mountHysteresis;
})();
